// extracted by mini-css-extract-plugin
export default {"about":"About_about__D7uiA","contentAbout":"About_contentAbout__f4zzM","imageAbout":"About_imageAbout__OXu30","textContentAbout":"About_textContentAbout__IcsrC"};